export default __webpack_public_path__ + "static/media/cain13.eecbd9c9.jpg";